import { Component, OnInit } from '@angular/core';
import { ReceiptService } from '../../../services/receipt.service';
import { ToastrService } from 'ngx-toastr';
//import { LocalApiConnectorService } from '../../../services/local-api-connector.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocationService } from '../../../services/location.service';

import { ConfigService } from '../../../services/endpoint.config.service';
import { TranslateService } from '@ngx-translate/core';
declare let $: any;

interface ICashOutByCurrency {
  count: number;
  currency: string;
  result: any;
  pagger: number;
  pagesContainer: number[]
}

@Component({
  selector: 'app-cashout',
  templateUrl: './cashout.component.html',
  styleUrls: ['./cashout.component.scss']
})
export class CashoutComponent implements OnInit {
  PAGE_COUNT = 5;
  base64Output: string;
  sss: any;

  cashoutByCurrency: ICashOutByCurrency[] = []

  constructor(private receipt: ReceiptService, private toaster: ToastrService,
    // private agent: LocalApiConnectorService, 
    private loader: NgxUiLoaderService,
    private locationService: LocationService,
    private configs: ConfigService,
    private translate: TranslateService) {
  }

  prepareSearchObject(take: number, skip: number, currency: string) {
    var searchObject = { skip: skip, take: take, currency: currency };
    return searchObject
  }

  getData(searchObject) {
    this.receipt.getCashOutReceipt(searchObject,
      (res) => {
        const index = this.cashoutByCurrency.findIndex((i) => i.currency == searchObject.currency);

        if (index > -1) {
          this.cashoutByCurrency[index].result = res.Results;
          this.cashoutByCurrency[index].count = res.Count;
          this.cashoutByCurrency[index].pagesContainer = new Array(Math.ceil(res.Count / this.PAGE_COUNT));
        }
      },
      (err) => { console.log(err) });
  }

  getSearchPage(pagger, currency: string) {
    this.updateCurrencyPagger(currency, 0, pagger);
    this.getData(this.prepareSearchObject(this.PAGE_COUNT, pagger * this.PAGE_COUNT, currency));
  }

  prevPage(currency: string) {
    const updatedPagger = this.updateCurrencyPagger(currency);

    if (updatedPagger != undefined) {
      this.getData(this.prepareSearchObject(this.PAGE_COUNT, updatedPagger * this.PAGE_COUNT, currency));
    }
  }

  nextPage(currency: string) {
    const updatedPagger = this.updateCurrencyPagger(currency, 1);

    if (updatedPagger != undefined) {
      this.getData(this.prepareSearchObject(this.PAGE_COUNT, updatedPagger * this.PAGE_COUNT, currency));
    }
  }

  // isNext (-1 - Prev, 0 - Update, 1 - Next)
  updateCurrencyPagger(currency: string, isNext = -1, tPagger = -1) {
    const index = this.cashoutByCurrency.findIndex((i) => i.currency == currency);

    if (index > -1) {
      const updatesPagger = tPagger != -1 ? tPagger : (isNext == 1 ?
        this.cashoutByCurrency[index].pagger + 1 :
        this.cashoutByCurrency[index].pagger - 1);

      this.cashoutByCurrency[index].pagger = updatesPagger;
      return this.cashoutByCurrency[index].pagger;
    }

    return undefined;
  }

  initLoad() {
    const searchObject = { skip: 0, take: this.PAGE_COUNT }
    this.receipt.getCashOutReceiptByCurrency(searchObject,
      (res) => {
        if (Array.isArray(res)) {
          this.cashoutByCurrency = [];
          if (res.length > 0) {
            res.forEach((x) => {
              this.cashoutByCurrency.push(this.generateCashoutObj(x));
            })
          }
        }
      },
      (err) => { console.log(err) });
  }

  generateCashoutObj(obj) {
    return {
      count: obj.Count,
      currency: obj.Currency,
      pagger: 0,
      result: obj.Results,
      pagesContainer: new Array(Math.ceil(obj.Count / this.PAGE_COUNT))
    } as ICashOutByCurrency
  }

  performChashOut() {
    this.loader.start();
    this.receipt.performCashOutReceipt((res) => {
      this.loader.stop();

      try {
        if (Array.isArray(res) && res.length > 0) {
          res.forEach((data) => {
            //var printers = JSON.parse(localStorage.getItem('printingSettings'))
            // var copies = JSON.parse(localStorage.getItem('printingSettings'))
            var report = data.Report as any;
            var fileToDownload = report.Url;
            var _this = this;
            var fileNameIndex = report.Url.lastIndexOf("/") + 1;
            var filename = report.Url.substr(fileNameIndex);
            var temp = "data:application/pdf;base64,";
            this.locationService.getBase64(report.Url, (baseRes) => {
              //this.base64Output = temp.concat(baseRes);
              this.base64Output = baseRes;
              _this.sss.print({
                'documentId': report.Type.ReportTypeId,
                'fileName': filename,
                'fileData': this.base64Output
              });
            }, (err) => {
      
            })
            window.open(fileToDownload, "download")
      
            // if (printers != null) {
            //   var type = 0;
            //   var copies = 0;
            //   type = printers.CashierOutReport.reportTypeId == report.Type.ReportTypeId ? printers.CashierOutReport.printer : 0
            //   type = printers.ReceiptLabelType.reportTypeId == report.Type.ReportTypeId ? printers.ReceiptLabelType.printer : type
            //   type = printers.TaxReceiptLabelType.reportTypeId == report.Type.ReportTypeId ? printers.TaxReceiptLabelType.printer : type
            //   type = printers.Waybillform.reportTypeId == report.Type.ReportTypeId ? printers.Waybillform.printer : type
            //   copies = printers.CashierOutReport.compies;
            //   copies = printers.ReceiptLabelType.compies;
            //   copies = printers.TaxReceiptLabelType.compies;
            //   copies = printers.Waybillform.compies;
      
            //   this.agent.print(() => {
      
            //     //   this.toaster.success("Printing process has been started!")
            //   }, () => {
            //     window.open(fileToDownload, "download")
            //   }, {
            //     PrinterName: type,
            //     file: fileToDownload,
            //     copies: copies
            //   })
            // }
            // else {
            //   window.open(fileToDownload,"download")
            // }
          })
        }
        this.toaster.success(`${this.translate.instant('pages.cashoutPage.cashoutPerformed')}`);
        this.initLoad();
      } catch(e) {
        this.initLoad();
      }
    }, () => { })
  }
  ngOnInit() {
    this.initLoad();

    this.sss = $("#dvamxprint").amxPrintMngr('992ada1b68b34b618173a221393ba8ce', this.configs.getEnviromentId());
    this.sss.start();
    this.sss.result = function (e) {
      var y = e;
    };
  }
}
